"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpBadge = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const badge_html_1 = __importDefault(require("./badge.html"));
let ItpBadge = class ItpBadge extends vue_1.default {
    id;
    text;
    value;
    variant;
    block;
    variantMap;
    colorCode;
    noBoxShadow;
    get className() {
        const result = {
            badge: true,
            'itp-badge': true,
            'display-block': this.block,
            'shadow-none': this.noBoxShadow,
            'd-inline-flex align-items-center justify-content-start': true
        }, variant = this.getVariant();
        if (variant) {
            result[`badge-${variant}`] = true;
        }
        if (this.colorCode) {
            result[`bg-${this.colorCode}`] = true;
        }
        return result;
    }
    getVariant() {
        if (this.variantMap && this.value) {
            return this.variantMap[this.value];
        }
        return this.variant;
    }
};
exports.ItpBadge = ItpBadge;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpBadge.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpBadge.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpBadge.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpBadge.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBadge.prototype, "block", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], ItpBadge.prototype, "variantMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpBadge.prototype, "colorCode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBadge.prototype, "noBoxShadow", void 0);
exports.ItpBadge = ItpBadge = __decorate([
    (0, vue_property_decorator_1.Component)({ template: badge_html_1.default })
], ItpBadge);
//# sourceMappingURL=badge.js.map